import { isFeatureEnabled } from "../../config/features";
import { AlertsBell } from "./AlertsBell";
import { ToolbarProfile } from "./ToolbarProfile";

// Slim app chrome. Filters moved out of this shared bar and onto each page (see
// FilterBar / usePageFilters): a single site-wide filter both read as confusing
// and could not be cleared. What remains here is genuinely global -- (when
// enabled) the alerts bell, and the account/settings block (moved off the
// sidebar so it sits top-right of the page). Import progress moved to the
// full-width ImportProgressBanner in AppShell (Unit 1). Feedback lives in the
// sidebar (above Import), so it is not duplicated here.
export function Toolbar() {
  return (
    <header
      aria-label="App toolbar"
      className="sticky top-0 z-10 flex h-12 shrink-0 items-center gap-3 border-b border-outline-variant bg-surface-container px-4"
    >
      <div className="ml-auto flex items-center gap-3">
        {isFeatureEnabled("alerts") ? <AlertsBell /> : null}
        <div className="mr-6">
          <ToolbarProfile />
        </div>
      </div>
    </header>
  );
}
